import { Table, TableContainer, useTheme, CircularProgress, TableCell, TableHead, TableRow, TableBody, Grid, Divider, Typography, TextField, Button, Autocomplete, FormControl, Checkbox, Tooltip, IconButton, Box, } from "@mui/material";
import React, { useEffect, useState } from "react";

// template
import Header from "../../../Layout/Header";
import CallAlertBar from "../../../Layout/Alertbar";
import CustomTableContainer from "../../../components/table/CustomTableContainer";

//icons
import AddCircleIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

//services
import AddStorageLocation from "../../master/AddStorageLocation";
import useStorageLocation from "../../../hooks/useStorageLocationList";
import ResponsiveBox from "../../../components/form/ResponsiveScrollBox";
import StorageLocationActionMenu from "./ActionMenu";
import ViewStorageLocationReportBySONumber from "../reports/StorageLocationReport";

// Date picker components
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { alpha, styled } from '@mui/material/styles';

// Utilities
import dayjs from 'dayjs';
import 'dayjs/plugin/customParseFormat';
import { useTranslation } from "react-i18next";
import GlobalConfig from "../../../config/date/GlobalConfig";

import useGetSONumberList from "../../../hooks/useStoreFGSalesOrderList";




import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";
import useUserPermissions from "../../../components/user-permission/UserPermission";
import useProductionTracking from "../../../hooks/useProductionTrackking";
import { exportToExcel } from "../../../components/ExportToExcel";
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import TableFilterRow from "../../../components/table/TableFilterRow";
import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";
import useDefaultParameterConfig from "../../../hooks/useDefaultParameterConfig";
import { Production_API_ENDPOINTS } from "../../../config/api/apiCallProduction";

const AddStorageLocationForFG = ({ handleBackWinderMachineEntry }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t } = useTranslation();
    const userPermissions = useUserPermissions();

    // message Process
    const [msgOpen, setMsgOpen] = useState(false);
    const [severityValue, setSeverityvalue] = useState('info');
    const [messageValue, setMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [alertTitleValue, setAlertTitleValue] = useState('');


    const [soNumber, setSONumber] = useState('');
    const [editShiftAssignmentID, setShiftAssignmentID] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [productList, setProductList] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);

    const [selectedStatus, setSelectedStatus] = useState('All');
    const [viewList, setViewList] = useState(false);
    const [selectedButtonName, setSelectedButtonName] = useState('addLocation');

    const [viewReport, setViewReport] = useState(false);
    const [downloadReport, setdownloadReport] = useState(false);
    const [reportDetail, setReportDetail] = useState([]);

    const { storageLocation, selectedStorageLocation, selectedStorageLocationID, setSelectedStorageLocation, setSelectedStorageLocationID, loadStorageLocationByID } = useStorageLocation(editShiftAssignmentID);

    // Date range States

    const [filterFromDate, setFilterFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [filterToDate, setFilterToDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [receivedDate, setReceivedDate] = useState(dayjs().format('DD/MMM/YYYY'));

    // skeleton progress 
    const [loading, setLoading] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);


    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);

    const { salesOrderNumber, selectedSalesOrderNumber, setSelectedSalesOrderNumber, setSelectedSalesOrderNumberID, ddloading, } = useGetSONumberList(0);
    const { loadProductionTrackingBySOAndCRNumber } = useProductionTracking();
    const { defaultParameterConfig } = useDefaultParameterConfig();


    // table sample data 

    const CustomTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} arrow placement="right-start" />
    ))({
        [`& .MuiTooltip-tooltip`]: {
            backgroundColor: colors.blueAccent[500],
            color: 'white',
            fontSize: '14px',
            borderRadius: '10px',
            padding: '10px',

        },
        [`& .MuiTooltip-arrow`]: {
            color: colors.blueAccent[500],
        },
    });



    const handleCallBack = () => {
        handleBackWinderMachineEntry();
    }
    // department change
    const handleDepartmentChange = async (event, value) => {
        if (!value) {
            setSelectedStorageLocation(null);
            setSelectedStorageLocationID(null);
            return; // Exit early if value is null
        }

        setSelectedStorageLocation(value);
        setSelectedStorageLocationID(value.id);
    };
    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        loadStorageLocationByID(0);

    };

    const handleFilterFromDate = (date) => {
        setFilterFromDate(dayjs(date));
    };

    const handleFilterToDate = (date) => {
        setFilterToDate(dayjs(date));
    };

    const handleFilterData = () => {

        let SelectedSO = typeof selectedSalesOrderNumber === 'string'
            ? selectedSalesOrderNumber
            : selectedSalesOrderNumber?.so_number || '';
        const SaveData = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_so_number: SelectedSO,
        }

        if (!viewReport) {
            setSaveLoading(true);
            callApi(API_ENDPOINTS.PRODUCTION_FILTER_DATA, 'POST', { 'Content-Type': 'application/json' }, SaveData)
                .then(data => {
                    if (data && data.length > 0) {
                        setProductList(data);
                        setViewList(true);
                        setSelectedRows([]);
                        loadProductionTrackingBySOAndCRNumber(0, SelectedSO, '');
                        setSaveLoading(false);
                    }
                    else {
                        setProductList([]);
                        setViewList(false);
                        setSelectedRows([]);
                        setSaveLoading(false);
                    }
                })
                .catch(error => {
                    alert(error.message);
                    setSaveLoading(false);
                });
        }


    }

    const [filters, setFilters] = useState({
        product_code: '',
        item_code: '',
        gsm: '',
        size: '',
        grain: '',
        grade: '',
        store_code: '',
        customer_name: '',
        supplier_name: '',
        indent_no: '',
        product_type: '',
    });





    const filteredData = productList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            //const newSelectedRows = productList.map((row) => row.id_product);
            const newSelectedRows = productList
                .filter((row) => row.store_code === null) // Exclude 'converted' rows
                .map((row) => row.id_product);
            setSelectedRows(newSelectedRows);
            return;
        }
        setSelectedRows([]);
    };
    
    const handleRowCheckboxClick = (event, rowId) => {
        const selectedIndex = selectedRows.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedRows, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedRows.slice(1);
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelectedRows = selectedRows.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedRows.slice(0, selectedIndex),
                ...selectedRows.slice(selectedIndex + 1),
            ];
        }

        setSelectedRows(newSelectedRows);


    };

    const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;

    const totalSelectedWeight = filteredData
        .filter((s) => selectedRows.includes(s.id_product))
        .reduce((sum, row) => sum + (parseFloat(row.weight) || 0), 0)
        .toFixed(1); // Limits to 1 decimal place



    const saveStorageLocation = async () => {

        if (!hasPermission(userPermissions, "FG Report", "Create")) {
            console.warn("User does not have permission to perform this action.");
            return; // Exit the function if permission is not granted
        }

        let isValid = true;
        let errorMessage = "";

        const selectedProducts = productList.filter((p) => selectedRows.includes(p.id_product));

        // Get distinct product_type values
        const selectedProductType = [...new Set(selectedProducts.map((p) => p.product_type))];

        let maxFgDate = null;

        if (selectedProducts.length > 0) {
            maxFgDate = selectedProducts
                .map((p) => dayjs(p.fg_date, "DD-MMM-YYYY")) // Convert `fg_date` to `dayjs` object
                .reduce((max, date) => (date.isAfter(max) ? date : max), dayjs(selectedProducts[0].fg_date, "DD-MMM-YYYY"));

            // Format maxFgDate for consistency
            maxFgDate = maxFgDate.format("YYYY-MM-DD HH:mm:ss");
        }

        // Convert receivedDate to `dayjs` and format it in the same way
        const p_store_receive_date = dayjs(receivedDate).format("YYYY-MM-DD HH:mm:ss");

        // Ensure `p_store_receive_date` is not less than `maxFgDate`
        if (maxFgDate && dayjs(p_store_receive_date).isBefore(dayjs(maxFgDate))) {
            isValid = false;
            errorMessage = "Storage Received date cannot be earlier than the maximum FG date.";
        } else if (!maxFgDate) {
            isValid = false;
            errorMessage = "No valid fg_date found in selected products.";
        }


        // Extracting required parameters
        const companyID = localStorage.getItem('companyid')?.trim();
        const userID = localStorage.getItem('userID')?.trim();
        const plantID = 1;  // Assuming plant ID is always 1
        const locationID = selectedStorageLocationID;



        // Validating each parameter
        if (!companyID) {
            isValid = false;
            errorMessage = "Company ID is missing.";
        } else if (!userID) {
            isValid = false;
            errorMessage = "User ID is missing.";
        } else if (!selectedProducts || selectedProducts.length === 0) {
            isValid = false;
            errorMessage = "Please select at least one product.";
        } else if (!locationID) {
            isValid = false;
            errorMessage = "Storage location is not selected.";
        }

        if (!isValid) {
            alert(errorMessage);
            return;
        }

        const saveData = {
            p_companyid: companyID,
            p_plantid: plantID,
            p_product_list: selectedProducts,
            p_id_location: locationID,
            p_user_name: userID,
            p_store_receive_date: dayjs(receivedDate).format('YYYY-MM-DD hh:mm:ss'),
            p_mode: 0,
            p_package_mode: selectedProductType[0],
        };
        setSaveLoading(true);
        await callApi(API_ENDPOINTS.PRODUCTION_SAVE_STORAGE_LOCATION, 'POST',
            { 'Content-Type': 'application/json' }, saveData)
            .then(data => {
                if (data && data.length > 0) {
                    // setProductList(data);
                    handleFilterData();
                    CallMessage('success', 'Storage location saved successfully', 'Info');
                    setSaveLoading(false);

                    if (defaultParameterConfig.length > 0) {
                        const matchingRows = defaultParameterConfig.filter(
                            row => row.p_name === "FG Stock Update" && row.p_default_value_code === '1'
                        );

                        if (matchingRows.length > 0) {                           
                            const parameter = {
                                p_companyid: companyID,
                                p_plantid: plantID,
                                p_user: userID,
                            };

                            callApi(Production_API_ENDPOINTS.FGStockUpdate, 'POST', { 'Content-Type': 'application/json' }, parameter)
                                .then(data => {
                                    if (data && data.length > 0) {
                                        if (data === "Stock updated successfully")
                                            CallMessage('success', 'FG Stock has been updated successfully', 'Info');
                                        else
                                            CallMessage('warning', data, 'Warning');
                                    }
                                })
                                .catch(error => {
                                    alert("API Error: " + error.message);
                                });
                        }
                    }
                }
            })
            .catch(error => {
                alert("API Error: " + error.message);
                setSaveLoading(false);
            });
    };




    //Reverse storage location status
    const reverseStorageLocation = async () => {

        if (!hasPermission(userPermissions, "FG Report", "Create")) {
            console.warn("User does not have permission to perform this action.");
            return; // Exit the function if permission is not granted
        }

        let isValid = true;
        let errorMessage = "";

        const selectedProducts = productList.filter((p) => selectedRows.includes(p.id_product));
        // Get distinct product_type values
        const selectedProductType = [...new Set(selectedProducts.map((p) => p.product_type))];

        let maxFgDate = null;

        if (selectedProducts.length > 0) {
            maxFgDate = selectedProducts
                .map((p) => dayjs(p.fg_date, "DD-MMM-YYYY")) // Convert `fg_date` to `dayjs` object
                .reduce((max, date) => (date.isAfter(max) ? date : max), dayjs(selectedProducts[0].fg_date, "DD-MMM-YYYY"));

            // Format maxFgDate for consistency
            maxFgDate = maxFgDate.format("YYYY-MM-DD HH:mm:ss");
        }

        // Convert receivedDate to `dayjs` and format it in the same way
        const p_store_receive_date = dayjs(receivedDate).format("YYYY-MM-DD HH:mm:ss");

        // Ensure `p_store_receive_date` is not less than `maxFgDate`
        if (maxFgDate && dayjs(p_store_receive_date).isBefore(dayjs(maxFgDate))) {
            isValid = false;
            errorMessage = "Storage Received date cannot be earlier than the maximum FG date.";
        } else if (!maxFgDate) {
            isValid = false;
            errorMessage = "No valid fg_date found in selected products.";
        }


        // Extracting required parameters
        const companyID = localStorage.getItem('companyid')?.trim();
        const userID = localStorage.getItem('userID')?.trim();
        const plantID = 1;  // Assuming plant ID is always 1
        const locationID = 0;



        // Validating each parameter
        if (!companyID) {
            isValid = false;
            errorMessage = "Company ID is missing.";
        } else if (!userID) {
            isValid = false;
            errorMessage = "User ID is missing.";
        } else if (!selectedProducts || selectedProducts.length === 0) {
            isValid = false;
            errorMessage = "Please select at least one product.";
        }
        //  else if (!locationID) {
        //     isValid = false;
        //     errorMessage = "Storage location is not selected.";
        // }


        if (!isValid) {
            alert(errorMessage);
            return;
        }

        const saveData = {
            p_companyid: companyID,
            p_plantid: plantID,
            p_product_list: selectedProducts,
            p_id_location: locationID,
            p_user_name: userID,
            p_store_receive_date: dayjs(receivedDate).format('YYYY-MM-DD hh:mm:ss'),
            p_mode: 1,
            p_package_mode: selectedProductType[0],
        };

        await callApi(API_ENDPOINTS.PRODUCTION_SAVE_STORAGE_LOCATION, 'POST',
            { 'Content-Type': 'application/json' }, saveData)
            .then(data => {
                if (data && data.length > 0) {
                    // setProductList(data);
                    handleFilterData();
                    CallMessage('success', 'Storage location has reversed successfully', 'Info');


                }
            })
            .catch(error => {
                alert("API Error: " + error.message);
            });
    };

    // call message
    const CallMessage = (serverityval, msg, title) => {
        setSeverityvalue(serverityval);
        setMessageValue(msg);
        setAlertTitleValue(title);
        setMsgOpen(true);
    };

    const handlecallProcess = (buttonName) => {
        if (buttonName === 'viewReport') {
            setViewReport(true);
            setdownloadReport(false);
            setViewList(false);
            fetchDataForReport();
        }
        else if (buttonName === 'addLocation') {
            setViewReport(false);
            setdownloadReport(false);
            setViewList(false);
        }
        else if (buttonName === 'save') {
            saveStorageLocation();
        }
        else if (buttonName === 'reverse') {
            reverseStorageLocation();
        }
        else if (buttonName === 'export') {
            handleExportToExcel();
        }
    }


    useEffect(() => {
        const fetchData = async () => {
            await fetchDataForReport();
        };
        fetchData();
    }, [currentPage, pageSize, filterFromDate, filterToDate, setFilterFromDate, setFilterToDate]);

    const fetchDataForReport = async () => {
        const p_companyid = localStorage.getItem('companyid');
        const p_from_date = dayjs(filterFromDate).startOf('day').format('YYYY-MM-DD HH:mm:ss');//dayjs(filterFromDate).format('YYYY-MM-DD hh:mm:ss');
        const p_to_date = dayjs(filterToDate).endOf('day').format('YYYY-MM-DD HH:mm:ss');//dayjs(filterToDate).format('YYYY-MM-DD hh:mm:ss');

        const para = {
            p_companyid: p_companyid,
            p_plantid: 1,
            p_from_date,
            p_to_date,
            p_so_number: soNumber,
            page: currentPage,
            pageSize: pageSize,
        };
        setLoading(true);
        try {
            const data = await callApi(API_ENDPOINTS.PRODUCTION_VIEW_STORAGE_LOCATION, 'POST', { 'Content-Type': 'application/json' }, para);
            if (data) setReportDetail(data); // Set the fetched data to party list
        } catch (error) {
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };

    const excelColumns = [
        { header: "ORDER ID", key: "order_no" },
        { header: "ORDER DATE", key: "rorder_date" },
        { header: "CUSTOMER NAME", key: "rcustomer_name" },
        { header: "CONSIGNEE NAME", key: "rconsignee_name" },
        { header: "QUALITY", key: "rquality" },
        { header: "GSM", key: "rgsm" },
        { header: "WIDTH", key: "rwidth" },
        { header: "LENGTH", key: "rlength" },
        { header: "GRADE", key: "rgrade" },
        { header: "ORDER QTY", key: "rorder_qty" },
        { header: "ACHIEVED QTY", key: "rach_qty" },
        { header: "FG QTY", key: "rfg_qty" },
        { header: "REEL STOCK", key: "rreel_stock" },
        { header: "NO OF REAM IN BUNDLE", key: "rno_of_reams_per_bundle" },
        { header: "NO OF REAM", key: "rno_of_ream" },
        { header: "REAM WEIGHT", key: "rream_weight" },
        { header: "NO OF BUNDLE", key: "rnumber_of_bundle" },
        { header: "NO OF LOOSE", key: "rnumber_of_loose" },
        { header: "REAM STOCK", key: "rream_stock" },
        { header: "LOCATION", key: "rstorage_location" },
        { header: "PLANNING NO", key: "rplanning_number" },
        { header: "FG RECEVING DATE", key: "rstorage_date" },
        { header: "SALES OFFICE", key: "rsales_office" },
        { header: "DESTINATION", key: "rdestination" },
    ];


    const dateColumnIndexes = [1]; // ORDER DATE

    const handleExportToExcel = () => {
        exportToExcel({
            data: reportDetail,
            fileName: 'FG RECEIVING REPORT.xlsx',
            sheetName: 'FG DETAIL',
            columns: excelColumns,           // 🔁 Fixed name
            dateColumnIndexes,
        });




    };


    // filter oprations 
    const columns = ['id_product', 'product_code', 'item_code', 'gsm', 'size', 'grain', 'grade', 'weight', 'store_code', 'stored_date', 'customer_name', 'supplier_name', 'indent_no', 'product_type', 'fg_date', 'sync_date'];
    const autoCompleteColumns = ['id_product', 'product_code', 'item_code', 'gsm', 'size', 'grain', 'grade', 'weight', 'store_code', 'stored_date', 'customer_name', 'supplier_name', 'indent_no', 'product_type', 'fg_date', 'sync_date'];
    // , 'status'
    const handleFilterChangeTable = (e, column) => {
        setFilters({ ...filters, [column]: e.target.value });
    };

    const uniqueValues = {
        id_product: [...new Set(productList.map(row => row.id_product))],
        product_code: [...new Set(productList.map(row => row.product_code))],
        item_code: [...new Set(productList.map(row => row.item_code))],
        gsm: [...new Set(productList.map(row => row.gsm))],
        size: [...new Set(productList.map(row => row.size))],
        grain: [...new Set(productList.map(row => row.grain))],
        weight: [...new Set(productList.map(row => row.weight))],
        store_code: [...new Set(productList.map(row => row.store_code))],
        customer_name: [...new Set(productList.map(row => row.customer_name))],
        supplier_name: [...new Set(productList.map(row => row.supplier_name))],
        indent_no: [...new Set(productList.map(row => row.indent_no))],
        product_type: [...new Set(productList.map(row => row.product_type))],
        fg_date: [...new Set(productList.map(row => row.fg_date))],
        sync_date: [...new Set(productList.map(row => row.sync_date))],

    };




    return (
        <>
            <Grid>
                <Grid item xs={12} sm={6} md={4} lg={2} mt={2} >

                    <Header title={selectedButtonName === 'addLocation' ? "Add Storage Location" : "View And Download FG Report"} subtitle="" callback={handleCallBack} />

                    <Divider />
                    <>
                        <StorageLocationActionMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} handlecallProcess={handlecallProcess} />
                        <Divider />
                    </>
                    <CallAlertBar parentRollMsgOpen={msgOpen} setParentRollMsgOpen={setMsgOpen} parentRollSeverityvalue={severityValue}
                        setParentRollSeverityvalue={setSeverityvalue} parentRollAlertTitleValue={alertTitleValue}
                        setParentRollAlertTitleValue={setAlertTitleValue} parentRollMessageValue={messageValue} setParentRollMessageValue={setMessageValue} />
                </Grid>
                {!viewReport ? (

                    <>
                        {hasPermission(userPermissions, "FG Report", "View") && (
                            // <Grid item xs={12} sm={6} md={4} lg={2}>
                            //     <Grid container>
                            //         <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={2}>
                            //             <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            //                 <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                            //                     <Grid item xs={12} sm={12} md={2.5} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                            //                         <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                            //                             Enter SO Number
                            //                         </Typography>
                            //                     </Grid>

                            //                     <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                            //                         <Autocomplete
                            //                             size="small"
                            //                             fullWidth
                            //                             freeSolo
                            //                             options={salesOrderNumber}
                            //                             value={selectedSalesOrderNumber}
                            //                             loading={ddloading} // Adds built-in loading support
                            //                             onChange={(event, newValue) => {
                            //                                 if (typeof newValue === "string") {
                            //                                     setSelectedSalesOrderNumber({ so_number: newValue });
                            //                                     setSelectedSalesOrderNumberID(null);
                            //                                 } else if (newValue) {
                            //                                     setSelectedSalesOrderNumber(newValue);
                            //                                     setSelectedSalesOrderNumberID(newValue.id || null);
                            //                                 } else {
                            //                                     setSelectedSalesOrderNumber(null);
                            //                                     setSelectedSalesOrderNumberID(null);
                            //                                 }
                            //                             }}
                            //                             onInputChange={(event, newInputValue) => {
                            //                                 if (newInputValue) {
                            //                                     setSelectedSalesOrderNumber({ so_number: newInputValue });
                            //                                 }
                            //                             }}
                            //                             getOptionLabel={(option) => (typeof option === "string" ? option : option?.so_number || "")}
                            //                             renderInput={(params) => (
                            //                                 <TextField
                            //                                     {...params}
                            //                                     label="Sales Order Number"
                            //                                     required
                            //                                     variant="outlined"
                            //                                     InputProps={{
                            //                                         ...params.InputProps,
                            //                                         endAdornment: (
                            //                                             <>
                            //                                                 {loading ? <CircularProgress color="inherit" size={20} /> : null}
                            //                                                 {params.InputProps.endAdornment}
                            //                                             </>
                            //                                         ),
                            //                                     }}
                            //                                 />
                            //                             )}
                            //                         />




                            //                     </Grid>
                            //                     <Grid item xs={12} sm={11} md={3.8} lg={1} xl={1}>
                            //                         <Button size="small" variant="contained" onClick={() => handleFilterData()} color="secondary" sx={{ textTransform: 'none' }} >Fetch </Button>
                            //                     </Grid>

                            //                     {viewList ? (<>
                            //                         <Grid item xs={12} sm={11} md={3.8} lg={1.5} xl={1}>
                            //                             <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                            //                                 Storage Location
                            //                             </Typography>
                            //                         </Grid>

                            //                         <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                            //                             <FormControl fullWidth size="small">
                            //                                 <Autocomplete
                            //                                     fullWidth
                            //                                     value={selectedStorageLocation}
                            //                                     onChange={handleDepartmentChange}
                            //                                     size="small"
                            //                                     style={{ fontSize: '12px' }}
                            //                                     options={storageLocation}
                            //                                     getOptionLabel={(option) => `${option.storage_location_code || ''}`}
                            //                                     renderInput={(params) =>
                            //                                         <TextField required
                            //                                             {...params} variant="outlined" />}
                            //                                 />
                            //                             </FormControl>
                            //                         </Grid>

                            //                         <Grid item xs={12} sm={11} md={3.8} lg={0.4} xl={0.3}>
                            //                             <Tooltip title="Add new operator" arrow>
                            //                                 <IconButton style={{ fontSize: 5 }} size="small" color="secondary" onClick={handleOpenModal} >
                            //                                     <AddCircleIcon />
                            //                                 </IconButton>
                            //                             </Tooltip>
                            //                         </Grid>

                            //                         <Grid item xs={12} sm={12} md={2.5} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                            //                             <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                            //                                 FG Receive Date
                            //                             </Typography>
                            //                         </Grid>
                            //                         <Grid item xs={12} sm={11} md={3.8} lg={1.8} xl={1.2}>
                            //                             <FormControl fullWidth size="small" >
                            //                                 <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                            //                                     <DatePicker
                            //                                         id="ToDate"
                            //                                         value={dayjs(receivedDate)}
                            //                                         format="DD-MMM-YYYY"
                            //                                         onChange={(date) => setReceivedDate(dayjs(date))}
                            //                                         slotProps={{ textField: { size: 'small', } }}
                            //                                         renderInput={(props) => <TextField {...props} />}
                            //                                     />
                            //                                 </LocalizationProvider>
                            //                             </FormControl>
                            //                         </Grid>
                            //                     </>) : (null)}
                            //                 </Grid>

                            //             </Grid>

                            //         </Grid>
                            //     </Grid>
                            // </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={2} mt={1}>
                                <Grid container spacing={2} padding="10px 0 0 20px" alignItems="center">
                                    <Grid item xs={12} md={2.5} lg={1.5} xl={1}>
                                        <Typography variant="h6" fontSize={14} textAlign="left">
                                            Enter SO Number
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12} md={3.8} lg={2} xl={1.5}>
                                        <Autocomplete
                                            size="small"
                                            fullWidth
                                            freeSolo
                                            options={salesOrderNumber}
                                            value={selectedSalesOrderNumber}
                                            loading={ddloading}
                                            onChange={(event, newValue) => {
                                                if (typeof newValue === "string") {
                                                    setSelectedSalesOrderNumber({ so_number: newValue });
                                                    setSelectedSalesOrderNumberID(null);
                                                } else if (newValue) {
                                                    setSelectedSalesOrderNumber(newValue);
                                                    setSelectedSalesOrderNumberID(newValue.id || null);
                                                } else {
                                                    setSelectedSalesOrderNumber(null);
                                                    setSelectedSalesOrderNumberID(null);
                                                }
                                            }}
                                            onInputChange={(event, newInputValue) => {
                                                if (newInputValue) {
                                                    setSelectedSalesOrderNumber({ so_number: newInputValue });
                                                }
                                            }}
                                            getOptionLabel={(option) => (typeof option === "string" ? option : option?.so_number || "")}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Sales Order Number"
                                                    required
                                                    variant="outlined"
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <>
                                                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                                {params.InputProps.endAdornment}
                                                            </>
                                                        ),
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={3.8} lg={1} xl={1}>
                                        <Button
                                            size="small"
                                            variant="contained"
                                            onClick={handleFilterData}
                                            color="secondary"
                                            sx={{ textTransform: 'none' }}
                                        >
                                            Fetch
                                        </Button>
                                    </Grid>

                                    {viewList && (
                                        <>
                                            <Grid item xs={12} md={2.5} lg={1.5} xl={1}>
                                                <Typography variant="h6" fontSize={14} textAlign="left">
                                                    Storage Location
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} md={3.8} lg={2} xl={1.5}>
                                                <FormControl fullWidth size="small">
                                                    <Autocomplete
                                                        fullWidth
                                                        value={selectedStorageLocation}
                                                        onChange={handleDepartmentChange}
                                                        size="small"
                                                        options={storageLocation}
                                                        getOptionLabel={(option) => `${option.storage_location_code || ''}`}
                                                        renderInput={(params) => (
                                                            <TextField required {...params} variant="outlined" />
                                                        )}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} md={0.5} lg={0.4} xl={0.3}>
                                                <Tooltip title="Add new operator" arrow>
                                                    <IconButton
                                                        size="small"
                                                        color="secondary"
                                                        onClick={handleOpenModal}
                                                    >
                                                        <AddCircleIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </Grid>

                                            <Grid item xs={12} md={2.5} lg={1.5} xl={1}>
                                                <Typography variant="h6" fontSize={14} textAlign="left">
                                                    FG Receive Date
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} md={3.8} lg={1.8} xl={1.2}>
                                                <FormControl fullWidth size="small">
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            id="ToDate"
                                                            value={dayjs(receivedDate)}
                                                            format="DD-MMM-YYYY"
                                                            onChange={(date) => setReceivedDate(dayjs(date))}
                                                            slotProps={{ textField: { size: 'small' } }}
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                            </Grid>
                                        </>
                                    )}
                                </Grid>
                            </Grid>

                        )}

                    </>


                ) : (<>
                    <Grid container padding="10px 0px 5px 10px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                        <Grid item xs={12} sm={12} md={1} lg={1.2} xl={1.2} display="flex-start" justifyContent="center">
                            <Typography variant="h6" > {t('prod_winder_machine.filter_by')}
                                <CustomTooltip
                                    title={
                                        <span>
                                            <b>The data has been filtered based on the stored location, stored date.</b> <br />
                                        </span>}
                                >
                                    <IconButton sx={{ marginLeft: "5px" }}>
                                        <InfoOutlinedIcon sx={{ color: colors.redAccent[500], fontSize: "16px" }} />
                                    </IconButton>
                                </CustomTooltip> </Typography>
                        </Grid>

                        <Grid item xs={12} sm={11} md={1.5} lg={1.5} xl={1.5}>
                            <FormControl fullWidth size="small">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        style={{ marginLeft: '10px' }}
                                        id="FromDate"
                                        value={dayjs(filterFromDate)}
                                        onChange={(date) => handleFilterFromDate(date)}
                                        slotProps={{ textField: { size: 'small', } }}
                                        renderInput={(props) => <TextField {...props} />}
                                        autoFocus
                                        format="DD-MMM-YYYY"
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>



                        <Grid item xs={12} sm={11} md={1.5} lg={1.5} xl={1.5}>
                            <FormControl fullWidth size="small" >
                                <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                                    <DatePicker
                                        id="ToDate"
                                        value={dayjs(filterToDate)}
                                        format="DD-MMM-YYYY"
                                        onChange={(date) => handleFilterToDate(date)}
                                        slotProps={{ textField: { size: 'small', } }}
                                        renderInput={(props) => <TextField {...props} />}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>
                        {/* <Grid item xs={12} sm={11} md={1.5} lg={1.5} xl={1.5}>
                            <Tooltip title="Back to menu">
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <IconButton onClick={() => handleExportToExcel()} >
                                        <DownloadIcon style={{ fontSize: "18px", color: "#009688" }} />
                                        <Typography variant="h6" sx={{ marginLeft: "5px" }}>Export Report</Typography>
                                    </IconButton>
                                   
                                </div>
                            </Tooltip>
                        </Grid> */}


                    </Grid></>)}



                {viewList ? (<>
                    <Grid item xs={12} sm={6} md={4} lg={2}>
                        <Grid container>
                            {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={2}>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                    <Grid container padding="0px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                        <Grid item xs={12} sm={12} md={2.5} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                Select Storage Location
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={11} md={3.8} lg={3} xl={2}>
                                            <FormControl fullWidth size="small">
                                                <Autocomplete
                                                    fullWidth
                                                    value={selectedStorageLocation}
                                                    onChange={handleDepartmentChange}
                                                    size="small"
                                                    style={{ fontSize: '12px' }}
                                                    options={storageLocation}
                                                    getOptionLabel={(option) => `${option.storage_location_code || ''}`}
                                                    renderInput={(params) =>
                                                        <TextField required
                                                            {...params} variant="outlined" />}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={11} md={3.8} lg={0.4} xl={0.3}>
                                            <Tooltip title="Add new operator" arrow>
                                                <IconButton style={{ fontSize: 5 }} size="small" color="secondary" onClick={handleOpenModal} >
                                                    <AddCircleIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={2.5} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                FG Receive Date
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={11} md={3.8} lg={3} xl={2}>
                                            <FormControl fullWidth size="small" >
                                                <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                                                    <DatePicker
                                                        id="ToDate"
                                                        value={dayjs(receivedDate)}
                                                        format="DD-MMM-YYYY"
                                                        onChange={(date) => setReceivedDate(dayjs(date))}
                                                        slotProps={{ textField: { size: 'small', } }}
                                                        renderInput={(props) => <TextField {...props} />}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>

                                    </Grid>

                                </Grid>

                            </Grid> */}
                            {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={2}>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                    <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                        <Grid item xs={12} sm={12} md={2.5} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                Store Receive Date
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={11} md={3.8} lg={3} xl={2}>
                                            <FormControl fullWidth size="small" >
                                                <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                                                    <DatePicker
                                                        id="ToDate"
                                                        value={dayjs(receivedDate)}
                                                        format="DD-MMM-YYYY"
                                                        onChange={(date) => setReceivedDate(dayjs(date))}
                                                        slotProps={{ textField: { size: 'small', } }}
                                                        renderInput={(props) => <TextField {...props} />}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>
                                        

                                    </Grid>

                                </Grid>

                            </Grid> */}
                        </Grid>
                    </Grid>

                    <Divider sx={{ marginTop: "10px", marginBottom: "10px" }} />

                    <Grid item xs={12} sm={6} md={12} lg={12} xl={12}>

                        {/* <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" > */}
                        <ResponsiveBox
                            customMaxHeight={{
                                xs: '60vh',  // Custom value for extra small devices
                                sm: '65vh',  // Custom value for small devices
                                md: '70vh',  // Custom value for medium devices
                                lg: '52.5vh',  // Custom value for large devices
                                xl: '68vh',  // Custom value for extra large devices
                            }}>
                            <CustomTableContainer colors={colors}>
                                <TableContainer>
                                    {saveLoading ? (
                                        <SkeletonTableLoader rows={5} columns={11} />
                                    ) : (
                                        <Table>
                                            <TableHead sx={{ backgroundColor: colors.primary[400] }}>
                                                <TableRow>
                                                    <TableCell sx={{ width: '50px' }}>
                                                        <Checkbox size="small" style={{ color: "secondary" }}
                                                            indeterminate={selectedRows.length > 0 && selectedRows.length < filteredData.length}
                                                            checked={selectedRows.length === filteredData.length}
                                                            onChange={handleSelectAllClick}
                                                        />
                                                    </TableCell>
                                                    <TableCell>PRODUCT CODE</TableCell>
                                                    <TableCell>QUALITY</TableCell>
                                                    <TableCell>GSM</TableCell>
                                                    <TableCell>SIZE</TableCell>
                                                    <TableCell>GRAIN</TableCell>
                                                    <TableCell>GRADE</TableCell>
                                                    <TableCell>WEIGHT</TableCell>
                                                    <TableCell>STORED LOCATION</TableCell>
                                                    <TableCell>FG RECEIVED DATE</TableCell>
                                                    <TableCell>CUSTOMER CODE</TableCell>
                                                    <TableCell>CONSIGNEE CODE</TableCell>
                                                    <TableCell>SO NUMBER</TableCell>
                                                    <TableCell>PRODUCT TYPE</TableCell>
                                                    <TableCell>PRODUCTION DATE</TableCell>
                                                    <TableCell>SYNC DATE</TableCell>
                                                    <TableCell>SYNC STATUS</TableCell>
                                                    
                                                </TableRow>
                                                <TableFilterRow
                                                    columns={columns}
                                                    filters={filters}
                                                    handleFilterChange={handleFilterChangeTable}
                                                    uniqueValues={uniqueValues}
                                                    autoCompleteColumns={autoCompleteColumns}
                                                />
                                            </TableHead>
                                            <TableBody>
                                                {filteredData.map((s, index) => (
                                                    <React.Fragment key={s.id}>
                                                        <TableRow sx={{ backgroundColor: index % 2 === 0 ? theme.palette.background.default : alpha(theme.palette.action.hover, 0.04), }}>
                                                            <TableCell sx={{ width: '50px' }}>
                                                                <Checkbox
                                                                    size="small"
                                                                    checked={isSelected(s.id_product)}
                                                                    onChange={(event) => handleRowCheckboxClick(event, s.id_product)}
                                                                />
                                                            </TableCell>

                                                            <TableCell sx={{ minWidth: '120px' }}>{s.product_code}</TableCell>
                                                            <TableCell sx={{ minWidth: '120px' }}>{s.item_code}</TableCell>
                                                            <TableCell>{s.gsm}</TableCell>
                                                            <TableCell>{s.size}</TableCell>
                                                            <TableCell>{s.grain}</TableCell>
                                                            <TableCell>{s.grade}</TableCell>
                                                            <TableCell>{s.weight}</TableCell>
                                                            <TableCell>{s.store_code}</TableCell>
                                                            <TableCell>{s.stored_date}</TableCell>
                                                            <TableCell sx={{ minWidth: '180px' }}>{s.customer_name}</TableCell>
                                                            <TableCell sx={{ minWidth: '180px' }}>{s.supplier_name}</TableCell>
                                                            <TableCell>{s.indent_no}</TableCell>
                                                            <TableCell>{s.product_type}</TableCell>
                                                            <TableCell>{s.fg_date}</TableCell>
                                                            <TableCell>{s.sync_date}</TableCell>
                                                            <TableCell sx={{ textAlign: 'center' }}>
                                                                {/* <Chip
                                                                label={s.sync_status ? 'Synced' : 'Not Synced'}
                                                                color={s.sync_status ? 'success' : 'error'}
                                                                size="small"
                                                            /> */}
                                                                {s.sync_status ? <CheckIcon color="success" /> : <CloseIcon color="error" />}
                                                            </TableCell>


                                                        </TableRow>
                                                    </React.Fragment>
                                                ))}

                                            </TableBody>
                                        </Table>
                                    )}
                                </TableContainer>
                            </CustomTableContainer>
                        </ResponsiveBox>
                    </Grid>

                    {/* </Grid> */}
                    {/* </Grid>
                        </Grid>
                    </Grid> */}
                    {/* Footer Section */}
                    <Box padding={1.5} display="flex" justifyContent="space-between" backgroundColor={colors.primary[400]} mt={2}>
                        <Typography variant="h6">
                            Selected Rows: <strong>{selectedRows.length}</strong>
                        </Typography>
                        <Typography variant="h6">
                            Selected Quantity: <strong>{totalSelectedWeight}</strong>
                        </Typography>
                    </Box>

                    <Divider sx={{ marginTop: "10px", marginBottom: "0px" }} />
                    {/* 
                    {hasPermission(userPermissions, "FG Report", "Create") && (
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Grid container sx={{ justifyContent: 'flex-end' }}>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={2}>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <Grid container padding="0px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                            <Grid item xs={12} sm={11} md={3.8} lg={12} xl={12} >
                                                <Box sx={{ display: "flex", justifyContent: "flex-end", marginRight: "10px" }}>
                                                    <Button onClick={() => reverseStorageLocation()} size="small" variant="contained" sx={{ textTransform: 'none', backgroundColor: "#00acc1" }}>Reverse Storage Location</Button>
                                                    <Button onClick={() => saveStorageLocation()} size="small" variant="contained" color="secondary" sx={{ textTransform: 'none', marginLeft: '5px' }}> {saveLoading ? 'Saving...' : 'Save'}</Button>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    )} */}

                    {/* <Typography>Tracking Details</Typography> */}
                    {/* tracking table */}
                    {/* <ResponsiveBox
                        customMaxHeight={{
                            xs: '60vh',  // Custom value for extra small devices
                            sm: '65vh',  // Custom value for small devices
                            md: '70vh',  // Custom value for medium devices
                            lg: '40vh',  // Custom value for large devices
                            xl: '70vh',  // Custom value for extra large devices
                        }}>
                        <CustomTableContainer colors={colors}>
                            <TableContainer>
                                <Table>
                                    <TableHead sx={{ backgroundColor: colors.primary[400] }}>
                                        <TableRow>
                                            
                                            <TableCell>SO NUMBER</TableCell>
                                            <TableCell>PARENT ROLL NO</TableCell>
                                            <TableCell>WINDER PROD.DATE</TableCell>
                                            <TableCell>WINDER SHIFT</TableCell>
                                            <TableCell>CHILD ROLL NUMBER</TableCell>
                                            <TableCell>QUALITY</TableCell>
                                            <TableCell>GSM</TableCell>
                                            <TableCell>WINDER REEL</TableCell>
                                            <TableCell>NUMBER OF CUTS</TableCell>
                                            <TableCell>REEL LENGTH</TableCell>
                                            <TableCell>REEL OD</TableCell>
                                            <TableCell>ACH QTY</TableCell>
                                            <TableCell>SIZE</TableCell>
                                            <TableCell>GRADE</TableCell>
                                            <TableCell>PROD TYPE</TableCell>
                                            <TableCell>REEL FG WT</TableCell>
                                            <TableCell>SHEET CONVERTION DATE</TableCell>
                                            <TableCell>TOTAL PALLET WT</TableCell>
                                            <TableCell>PALLET COUNT</TableCell>
                                           
                                            <TableCell>
                                                <IconButton onClick={handleOpen}>
                                                    <Searchicon style={{ fontSize: "16px" }} />
                                                </IconButton>
                                                <Modal
                                                    open={openDateRangeDialog}
                                                    onClose={handleClose}
                                                    aria-labelledby="modal-modal-title"
                                                    aria-describedby="modal-modal-description"
                                                >
                                                    <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                        <TextField
                                                            label="Product Code"
                                                            name="product_code"
                                                            value={filters.product_code}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <TextField
                                                            label="QUALITY"
                                                            name="item_code"
                                                            value={filters.item_code}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />

                                                        <TextField
                                                            label="GSM"
                                                            name="gsm"
                                                            value={filters.gsm}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <TextField
                                                            label="SIZE"
                                                            name="size"
                                                            value={filters.size}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <TextField
                                                            label="GRAIN"
                                                            name="grain"
                                                            value={filters.grain}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <TextField
                                                            label="GRADE"
                                                            name="grade"
                                                            value={filters.grade}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <TextField
                                                            label="WEIGHT"
                                                            name="weight"
                                                            value={filters.weight}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <TextField
                                                            label="STORED LOCATION"
                                                            name="store_code"
                                                            value={filters.store_code}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <TextField
                                                            label="Customer Name"
                                                            name="customer_name"
                                                            value={filters.customer_name}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <TextField
                                                            label="Supplier Name"
                                                            name="supplier_name"
                                                            value={filters.supplier_name}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <TextField
                                                            label="Indent Number"
                                                            name="indent_no"
                                                            value={filters.indent_no}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <TextField
                                                            label="Product Type"
                                                            name="product_type"
                                                            value={filters.product_type}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <Button variant="contained" onClick={handleClose} style={{ marginTop: 10 }}>
                                                            Apply Filter
                                                        </Button>
                                                    </Box>
                                                </Modal>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                        {productionTracking.map((s) => (
                                            <React.Fragment key={s.id}>
                                                <TableRow>
                                                    

                                                    <TableCell>{s.so_number}</TableCell>
                                                    <TableCell>{s.parent_roll_number}</TableCell>
                                                    <TableCell>{s.winder_date}</TableCell>
                                                    <TableCell>{s.w_shift_code}</TableCell>
                                                    <TableCell>{s.cr_numbers}</TableCell>
                                                    <TableCell>{s.quality}</TableCell>
                                                    <TableCell>{s.gsm}</TableCell>
                                                    <TableCell>{s.winder_reel}</TableCell>
                                                    <TableCell>{s.cut_sheet}</TableCell>
                                                    <TableCell>{s.reel_length}</TableCell>
                                                    <TableCell>{s.reel_od}</TableCell>
                                                    <TableCell>{s.ach_qty}</TableCell>
                                                    <TableCell>{s.width} X {s.length}</TableCell>
                                                    <TableCell>{s.grade}</TableCell>
                                                    <TableCell>{s.prod_mode}</TableCell>
                                                    <TableCell>{s.reel_weightment_wt}</TableCell>
                                                    <TableCell>{s.s_date}</TableCell>
                                                    <TableCell>{s.total_pallet_wt}</TableCell>
                                                    <TableCell>{s.pallet_count}</TableCell>
                                                   


                                                </TableRow>
                                            </React.Fragment>
                                        ))}

                                    </TableBody>
                                </Table>

                            </TableContainer>
                        </CustomTableContainer>
                    </ResponsiveBox> */}
                </>) : (null)}
                {viewReport ? (<><ViewStorageLocationReportBySONumber reportDetail={reportDetail} loadingOrderItemDet={loading} /> </>) : (null)}
                {isModalOpen && < AddStorageLocation onClose={handleCloseModal} open={isModalOpen} />}

            </Grid>
        </>
    );
};
export default AddStorageLocationForFG;